var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sidebar-menu-page-small" }, [
      _c(
        "ul",
        [
          _vm._l(_vm.navbars, function(item) {
            return [
              item.routerName === "Analysis"
                ? _c(
                    "li",
                    {
                      key: item.routerName,
                      class: {
                        active: item.activeRouters.includes(_vm.$route.name)
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "item-menu",
                          attrs: {
                            href: "#analysis-submenu",
                            "data-toggle": "collapse"
                          },
                          on: { click: _vm.toggleAnalysisSubmenu }
                        },
                        [
                          _c("span", { staticClass: "nav-label" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _vm._v(" "),
                          _c(
                            "i",
                            {
                              staticClass: "fa",
                              attrs: { "aria-hidden": "true" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.isOpenAnalysisSubmenu ? "-" : "+")
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.analysisSubmenu.length > 0
                        ? _c(
                            "ul",
                            {
                              staticClass: "nav-second-level collapse",
                              attrs: { id: "analysis-submenu" }
                            },
                            _vm._l(_vm.analysisSubmenu, function(sub) {
                              return _c(
                                "li",
                                {
                                  key: sub.dispOrder,
                                  class: {
                                    active:
                                      _vm.$route.params.id &&
                                      _vm.$route.params.id === sub.dispOrder
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "item-sub-menu",
                                      attrs: {
                                        to: {
                                          name: item.routerName,
                                          params: { id: sub.dispOrder }
                                        }
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          _vm.$emit("handleTogglePageSmallMenu")
                                        }
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "nav-label" }, [
                                        _vm._v(_vm._s(sub.menuName))
                                      ]),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fa fa-angle-right",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                : item.routerName === "Premium"
                ? _c(
                    "li",
                    {
                      key: item.routerName,
                      class: {
                        active: item.activeRouters.includes(_vm.$route.name)
                      }
                    },
                    [
                      _c(
                        _vm.isBasicPlan ? "a" : "router-link",
                        {
                          tag: "component",
                          staticClass: "item-menu",
                          attrs: {
                            href: _vm.isBasicPlan
                              ? "https://salemon.my.canva.site/premiumplan"
                              : null,
                            to: !_vm.isBasicPlan
                              ? { name: item.routerName }
                              : null,
                            target: _vm.isBasicPlan ? "_blank" : null
                          },
                          nativeOn: {
                            click: function($event) {
                              _vm.isOpenAnalysisSubmenu = false
                              _vm.$emit("handleTogglePageSmallMenu", true)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "nav-label" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-angle-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ],
                    1
                  )
                : _c(
                    "li",
                    {
                      key: item.routerName,
                      class: {
                        active: item.activeRouters.includes(_vm.$route.name)
                      }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item-menu",
                          attrs: {
                            to: { name: item.routerName, params: item.params }
                          },
                          nativeOn: {
                            click: function($event) {
                              _vm.isOpenAnalysisSubmenu = false
                              _vm.$emit("handleTogglePageSmallMenu", true)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "nav-label" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-angle-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ],
                    1
                  )
            ]
          }),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "item-menu",
                on: {
                  click: function($event) {
                    _vm.$emit("doLogout")
                  }
                }
              },
              [
                _c("span", { staticClass: "nav-label" }, [
                  _vm._v("ログアウト")
                ]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa fa-angle-right",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("p", { staticClass: "pd-l-15" }, [
        _vm._v("version: " + _vm._s(_vm.appVersion))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pd-l-15 pd-t-20 other" }, [
        _c(
          "a",
          {
            staticClass: "text--underline",
            attrs: { href: _vm.downloadUrl, download: "", target: "_blank" }
          },
          [_c("span", [_vm._v("利用規約")])]
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "text--underline",
            attrs: { href: _vm.downloadUrlV2, download: "", target: "_blank" }
          },
          [_c("span", [_vm._v("プライバシーポリシー")])]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "full-width mr-t-30" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary full-width",
            on: {
              click: function($event) {
                _vm.$emit("handleTogglePageSmallMenu")
              }
            }
          },
          [_vm._v("閉じる")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "sidebar-overlay",
      on: {
        click: function($event) {
          _vm.$emit("handleTogglePageSmallMenu")
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09956e66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09956e66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenuPageSmall.vue
// module id = null
// module chunks = 